import { BaseButtonProps } from "@/type/sifPageTypes";

type PrimaryButtonProps = BaseButtonProps;

export function SIFPrimaryButton({
  children,
  onClick,
  buttonSize = "big",
  disabled = false,
  maxWidth = true,
  display = "flex",
  className = "",
  ariaLabel,
}: PrimaryButtonProps) {
  return (
    <button
      aria-label={ariaLabel}
      onClick={onClick}
      disabled={disabled}
      className={`group ${display === "block" ? "block" : "flex items-center justify-center gap-1.5"} ${buttonSize === "big" ? "text-sm sm:text-base py-3 sm:py-3.5 rounded-xl" : "text-2xs sm:text-sm py-2 rounded-2lg"} ${maxWidth ? "w-full xs:max-w-56" : "w-full"} font-semibold text-black leading-1.5! border border-white bg-white transition duration-300 disabled:opacity-50 disabled:pointer-events-none hover:bg-transparent hover:text-white ${className}`}
    >
      {children}
    </button>
  );
}
